import "../components/css/payment.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import mainurl from "../config/mainurl.mjs";
import { Icon } from "@iconify/react";
import secureLocalStorage from "react-secure-storage";

function Paymentstatus() {
  let stausinterval;
  let usercc = secureLocalStorage.getItem("CC");
  let useruid = secureLocalStorage.getItem("uid");
  let pay_id = secureLocalStorage.getItem("payid");
  const [txndata, settxndata] = useState({});
  const [show, setshow] = useState(false);
  const [Statustime, setStatustime] = useState(10);

  const Navigate = useNavigate();

  async function statusapi() {
    await fetch(`${mainurl}/txndetails`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        payid: pay_id,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        setshow(true);
        settxndata(result);
      });
  }
  function timefunc() {
    setStatustime(Statustime - 1);
  }
  useEffect(() => {
    stausinterval = setInterval(timefunc, 1000);
    if (Statustime == 0) {
      secureLocalStorage.setItem("status", `${useruid}pStatus`);
      clearInterval(stausinterval);
      Navigate("/estampform");
    }
    return () => {
      clearInterval(stausinterval);
    };
  }, [Statustime]);
  useEffect(() => {
    if (secureLocalStorage.getItem("status") !== `${useruid}pc`) {
      secureLocalStorage.clear();
      Navigate("/");
    } else {
      statusapi();
    }
  }, []);

  return (
    <>
      <div className="container">
        {show === false ? (
          <Icon
            icon="svg-spinners:6-dots-scale"
            color="orange"
            width="50"
            height="50"
          />
        ) : (
          <div className="payment-container">
            <div>
              <div className="successful-icon">
                <svg
                  class="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    class="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    class="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="para text-center font-semibold mx-[15px] mt-4 mb-4">
                  Payment Sucessful! Thankyou for your Transaction.
                </p>
              </div>
              <div className="table-details">
                <table className="">
                  <tr>
                    <th className="small-text font-medium" colSpan={2}>
                      Transection details
                    </th>
                  </tr>
                  <tr>
                    <td className="small-text">Status</td>
                    <td className="small-text">
                      {txndata.status == "captured" ? "success" : ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="small-text">Transection ID</td>
                    <td className="small-text">{txndata.txnid}</td>
                  </tr>
                  <tr>
                    <td className="small-text">Date</td>
                    <td className="small-text">{txndata.date}</td>
                  </tr>
                  <tr>
                    <td className="small-text">Payment Mode</td>
                    <td className="small-text">{txndata.mode}</td>
                  </tr>
                  <tr>
                    <td className="small-text">Bank Name</td>
                    <td className="small-text">{txndata.bankname}</td>
                  </tr>
                  <tr className="last-tr">
                    <td className="small-text">Bank Account</td>
                    <td className="small-text">{txndata.bankacno}</td>
                  </tr>
                </table>
              </div>
              <div className="small-text text-center mt-8">
                Re-directing you in &nbsp;{" "}
                <Link className="link-text">
                  00:{Statustime < 10 ? `0${Statustime}` : Statustime} sec
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default Paymentstatus;
